import { createElementHook, createElementObject, createLayerHook, updateMediaOverlay } from './core';
// import { SVGOverlay as LeafletSVGOverlay } from '@anlan/gs-map';
import { forwardRef, useImperativeHandle } from 'react';
import type { ForwardedRef, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import L from '@anlan/gs-map';
import type { LatLngBoundsExpression, LeafletEventHandlerFnMap, SVGOverlay as LeafletSVGOverlayInstance } from '@anlan/gs-map';
import type { LeafletContextInterface, MediaOverlayProps } from './core';
const LeafletSVGOverlay = L.SVGOverlay;

interface SVGOverlayLayerProps extends MediaOverlayProps {
    attributes?: Record<string, string>
    children?: ReactNode
}

export interface SVGOverlayProps {
    attribution?: string
    attributes?: Record<string, string>
    bounds: LatLngBoundsExpression
    children?: ReactNode
    eventHandlers?: LeafletEventHandlerFnMap
    opacity?: number
    pane?: string
    zIndex?: number
}

export const useSVGOverlayElement = createElementHook<LeafletSVGOverlayInstance, SVGOverlayLayerProps, SVGSVGElement>(function createSVGOverlay(props: SVGOverlayLayerProps, context: LeafletContextInterface) {
    const { attributes , bounds , ...options } = props;
    const container = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    container.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    if (attributes != null) {
        Object.keys(attributes).forEach((name)=>{
            container.setAttribute(name, attributes[name] ?? '');
        });
    }
    const overlay = new LeafletSVGOverlay(container, bounds, options);
    return createElementObject(overlay, context, container);
}, updateMediaOverlay);
export const useSVGOverlay = createLayerHook(useSVGOverlayElement);
function SVGOverlayComponent({ children , ...options }: SVGOverlayProps, forwardedRef: ForwardedRef<LeafletSVGOverlayInstance>) {
    const overlayOptions: SVGOverlayLayerProps = {
        ...options,
        children
    };
    const { instance , container  } = useSVGOverlay(overlayOptions).current;
    useImperativeHandle(forwardedRef, ()=>instance, [instance]);
    return container == null || children == null ? null : /*#__PURE__*/ createPortal(children, container);
}
export const SVGOverlay = /*#__PURE__*/ forwardRef<LeafletSVGOverlayInstance, SVGOverlayProps>(SVGOverlayComponent);
